var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex flex-row items-center justify-center p-2 text-white font-bold gap-2 bg-green-800 hover:bg-green-600 rounded-md",attrs:{"href":"https://wa.me/84909277741","target":"_blank","rel":"noopener noreferrer","aria-label":"Chat on WhatsApp"}},[_c('i',{staticClass:"bi bi-whatsapp text-xl"}),_vm._v(" Chat on WhatsApp\n")])
}]

export { render, staticRenderFns }